import { Woonstad_Foundation_Portfolio_Api_Models_WRM_StadswonenAdvertisement } from '@woonstad/api-client-stadswonen-aanbod';
import { Woonstad_Foundation_Portfolio_Api_Features_Advertising_Models_Advertisement } from '@woonstad/api-client-woonstad-aanbod';
import { hasValue } from '@woonstad/helpers-utils';

export const advertCardLandscapeUspsWoonstad = (
  advert: Woonstad_Foundation_Portfolio_Api_Features_Advertising_Models_Advertisement,
) => {
  const usps = [];

  // Layers is actually the floor number of the entrance
  if (hasValue(advert.unit?.propertySpecification?.layers)) usps.push(advert.unit?.propertySpecification?.layers === 0 ? 'Begane grond' : `${advert.unit?.propertySpecification?.layers}e verdieping`);
  if (advert.unit?.propertySpecification?.surface) usps.push(`${advert.unit?.propertySpecification?.surface}m²`);
  if (advert.unit?.roomSpecification?.rooms) usps.push(`${advert.unit?.roomSpecification?.rooms} kamers`);

  return usps;
};

export const advertCardSquareUspsWoonstad = (
  advert: Woonstad_Foundation_Portfolio_Api_Features_Advertising_Models_Advertisement,
) => {
  const usps = [];
  // Layers is actually the floor number of the entrance
  if (advert.unit?.propertySpecification?.layers && advert.unit?.propertySpecification?.layers === 0) usps.push('Begane grond');
  if (advert.unit?.propertySpecification?.layers && advert.unit?.propertySpecification?.layers === 1) usps.push('Eerste verdieping');
  if (advert.unit?.propertySpecification?.layers && advert.unit?.propertySpecification?.layers === 2) usps.push('Tweede verdieping');
  if (advert.unit?.propertySpecification?.layers && advert.unit?.propertySpecification?.layers === 3) usps.push('Derde verdieping');
  if (advert.unit?.propertySpecification?.layers && advert.unit?.propertySpecification?.layers > 3) usps.push(`${advert.unit?.propertySpecification?.layers}e verdieping`);
  if (advert.unit?.propertySpecification?.surface) usps.push(`${advert.unit?.propertySpecification?.surface}m²`);
  if (advert.unit?.roomSpecification?.rooms) usps.push(`${advert.unit?.roomSpecification?.rooms} kamers`);

  return usps;
};

export const advertCardLandscapeUspsStadswonen = (
  advert: Woonstad_Foundation_Portfolio_Api_Models_WRM_StadswonenAdvertisement,
) => {
  const untilDate = advert.isoUntil ? new Date(advert.isoUntil) : undefined;

  const untilParsedUSP = untilDate
    ? Intl.DateTimeFormat('nl-NL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(untilDate)
    : undefined;

  const availableDate = advert.isoAvailable ? new Date(advert.isoAvailable) : undefined;

  const availableParsedUSP = availableDate
    ? Intl.DateTimeFormat('nl-NL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(availableDate)
    : undefined;

  const usps = [];

  if (availableDate) usps.push(`Beschikbaar per: ${availableParsedUSP}`);
  if (untilDate) usps.push(`Reageer tot en met: ${untilParsedUSP}`);

  // Nested array will be joined with dots
  if (advert.objectType || advert.surface || advert.gender) {
    const innerUsp = [];
    if (advert.objectType) innerUsp.push(advert.objectType);
    if (advert.surface) innerUsp.push(`${advert.surface}m²`);
    if (advert.gender === 'male') innerUsp.push('Geslacht: man');
    if (advert.gender === 'female') innerUsp.push('Geslacht: vrouw');

    usps.push(innerUsp);
  }

  return usps;
};

export const advertCardSquareUspsStadswonen = (
  advert: Woonstad_Foundation_Portfolio_Api_Models_WRM_StadswonenAdvertisement,
) => {
  const usps = [];
  if (advert.objectType) usps.push(advert.objectType);
  if (advert.surface) usps.push(`${advert.surface}m²`);
  if (advert.gender === 'male') usps.push('Geslacht: man');
  if (advert.gender === 'female') usps.push('Geslacht: vrouw');

  return usps;
};
